// src/components/StarField.jsx
// A quiet, mystical starfield backdrop: twinkling stars in white/gold/purple,
// plus a couple of rare shooting stars. Pure CSS-driven animation, JS only
// randomizes placement/timing once on mount (same pattern as Particles.jsx).
import { useEffect, useRef } from "react";

const STAR_COLORS = ["#ffffff", "#e8c97a", "#c9a84c", "#9b7fd4"];

export default function StarField({ count = 110, shootingStars = 2 }) {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    for (let i = 0; i < count; i++) {
      const star = document.createElement("div");
      star.className = "toa-star";
      const size = Math.random() < 0.82 ? 1 + Math.random() * 1.3 : 2 + Math.random() * 1.7;
      const color = STAR_COLORS[Math.floor(Math.random() * STAR_COLORS.length)];
      star.style.cssText = `
        left:${Math.random() * 100}%;
        top:${Math.random() * 100}%;
        width:${size}px;
        height:${size}px;
        background:${color};
        box-shadow:0 0 ${size * 2.5}px ${color};
        animation-duration:${2.4 + Math.random() * 5}s;
        animation-delay:${Math.random() * 6}s;
      `;
      container.appendChild(star);
    }

    for (let i = 0; i < shootingStars; i++) {
      const shoot = document.createElement("div");
      shoot.className = "toa-shooting-star";
      const delay = 6 + Math.random() * 14;
      shoot.style.cssText = `
        top:${5 + Math.random() * 40}%;
        left:${Math.random() * 40}%;
        animation-delay:${delay}s, ${delay}s;
        animation-duration:${1.8 + Math.random() * 0.8}s;
      `;
      container.appendChild(shoot);
    }
  }, [count, shootingStars]);

  return <div className="toa-starfield" ref={ref} />;
}